import { TableData } from "../utils/pdfHelpers";

export const mockTableData: TableData[] = [
  {
    id: 1,
    patient_name: "Jiya (65/M)",
    patient_id: "ID-3456",
    registration_no: "123456",
    admission_type: "OP",
    mod_study: "CT Brain Plain",
    mod_study_id: "1,230",
    scan_time: "25 Mar 2021",
    status: "Completed",
    status_date: "2024-01-15",
    referring_phy: "Dr. Gopi Saharan",
    referring_phy_type: "Neurologist",
    hospital: "5C Hospital, Bengaluru",
    hospital_id:"H-001",
    grade: "2A",
    type:'review',
    isCritical:false,
    isDocumentUploaded:"no",
    aiGraded:true,
  },
  {
    id: 2,
    patient_name: "Shivaramu (50/M)",
    patient_id: "ID-2334",
    registration_no: "123455",
    admission_type: "IP",
    mod_study: "MRI Brain Plain",
    mod_study_id: "1,231",
    scan_time: "2 May 25",
    status: "Completed",
    status_date: "2024-02-20",
    referring_phy: "Dr. Rajesh Kumar",
    referring_phy_type: "Neurologist",
    hospital: "5C Hospital, Delhi",
    hospital_id:"H-002",
    grade: "2B",
    type:'review',
    isCritical:false,
    isDocumentUploaded:"no",
    aiGraded:false,
  },
  {
    id: 3,
    patient_name: "MR.Keshav (85/M)",
    patient_id: "ID-5678",
    registration_no: "123457",
    admission_type: "OP",
    mod_study: "XRAY Radiograph Chest -AP",
    mod_study_id: "1,232",
    scan_time: "3 May 25",
    status: "Completed",
    status_date: "2024-03-10",
    referring_phy: "Dr. Chandrashekar M. O.",
    referring_phy_type: "Pulmonologist",
    hospital: "5C Hospital, Hyderabad",
    hospital_id:"H-003",
    grade: "1A",
    type:'review',
    isCritical:false,
    isDocumentUploaded:"no",
    aiGraded:true,
  },
  {
    id: 4,
    patient_name: "B.Naveen (41/M)",
    patient_id: "ID-4546",
    registration_no: "456767",
    admission_type: "IP",
    mod_study: "MRI Brain Plain And Contrast",
    mod_study_id: "1,454",
    scan_time: "24 Oct 24",
    status: "Completed",
    status_date: "2024-04-05",
    referring_phy: "Dr. Suresh Reddy",
    referring_phy_type: "Neurologist",
    hospital: "5C Hospital, Jaipur",
    hospital_id:"H-004",
    grade: "2B",
    type:'student',
    isCritical:false,
    isDocumentUploaded:"no",
  },
  {
    id: 5,
    patient_name: "Ragunathan (36/M)",
    patient_id: "ID-5657",
    registration_no: "240356",
    admission_type: "IP",
    mod_study: "CT Brain Plain & Face Plain",
    mod_study_id: "2,455",
    scan_time: "17 Mar 23",
    status: "Completed",
    status_date: "2024-05-12",
    referring_phy: "Dr. Udhaya Kumar",
    referring_phy_type: "Neurologist",
    hospital: "5C Hospital, Bengaluru",
    hospital_id:"H-001",
    grade: "1A",
    type:'student',
    isCritical:false,
    isDocumentUploaded:"no",
    aiGraded:true,
  },
  {
    id: 6,
    patient_name: "Jivanbhai (70/M)",
    patient_id: "ID-7899",
    registration_no: "345677",
    admission_type: "OP",
    mod_study: "CT Abdomen & Pelvis Plain",
    mod_study_id: "4,5567",
    scan_time: "31 Aug 12",
    status: "Completed",
    status_date: "2024-06-18",
    referring_phy: "Dr. Amit Patel",
    referring_phy_type: "Gastroenterologist",
    hospital: "5C Hospital, Delhi",
    hospital_id:"H-002",
    grade: "3A",
    type:'student',
    isCritical:false,
    isDocumentUploaded:"no",
  },
  {
    id: 7,
    patient_name: "Neelam Kumari (51/F)",
    patient_id: "ID-4677",
    registration_no: "948594",
    admission_type: "IP",
    mod_study: "XRAY Radiograph PNS",
    mod_study_id: "7,4456",
    scan_time: "23 Aug 24",
    status: "Completed",
    status_date: "2024-07-25",
    referring_phy: "Dr. Venkateshwar Rao",
    referring_phy_type: "ENT Specialist",
    hospital: "5C Hospital, Hyderabad",
    hospital_id:"H-003",
    grade: "2A",
    type:'radiologist',
    isCritical:false,
    isDocumentUploaded:"no",
    aiGraded:true,
  },
  {
    id: 8,
    patient_name: "Niyati Mahato (71/F)",
    patient_id: "ID-8354",
    registration_no: "467778",
    admission_type: "OP",
    mod_study: "MRI MRCP",
    mod_study_id: "9,4545",
    scan_time: "17 Jan 21",
    status: "Completed",
    status_date: "2024-08-30",
    referring_phy: "Dr. Pratibha Sharma",
    referring_phy_type: "Gastroenterologist",
    hospital: "5C Hospital, Jaipur",
    hospital_id:"H-004",
    grade: "1A",
    type:'radiologist',
    isCritical:false,
    isDocumentUploaded:"no",
  },
  {
    id: 9,
    patient_name: "Adsul Vivek (52/M)",
    patient_id: "ID-2355",
    registration_no: "9454",
    admission_type: "IP",
    mod_study: "CT Abdomen & Pelvis Triphasic",
    mod_study_id: "8,34566",
    scan_time: "3 July 23",
    status: "Completed",
    status_date: "2024-09-14",
    referring_phy: "Dr. Anand Desai",
    referring_phy_type: "Gastroenterologist",
    hospital: "5C Hospital, Bengaluru",
    hospital_id:"H-001",
    grade: "2A",
    type:'radiologist',
    isCritical:false,
    isDocumentUploaded:"no",
  },
  {
    id: 10,
    patient_name: "Shivaramu (50/M)",
    patient_id: "ID-2334",
    registration_no: "123455",
    admission_type: "IP",
    mod_study: "MRI Brain",
    mod_study_id: "1,231",
    scan_time: "2 May 25",
    status: "Completed",
    status_date: "2024-10-22",
    referring_phy: "Dr. Rajesh Kumar",
    referring_phy_type: "Neurologist",
    hospital: "5C Hospital, Delhi",
    hospital_id:"H-002",
    grade: "Yes",
    type:'clinical',
    isCritical:true,
    isDocumentUploaded:"Yes",
  },
  {
    id: 11,
    patient_name: "MR.Keshav (85/M)",
    patient_id: "ID-5678",
    registration_no: "123457",
    admission_type: "OP",
    mod_study: "XRAY Radiograph Chest",
    mod_study_id: "1,232",
    scan_time: "3 May 25",
    status: "Completed",
    status_date: "2024-11-08",
    referring_phy: "Dr. Chandrashekar M. O.",
    referring_phy_type: "Pulmonologist",
    hospital: "5C Hospital, Hyderabad",
    hospital_id:"H-003",
    grade: "Yes",
    type:'clinical',
    isCritical:true,
    isDocumentUploaded:"Yes",
  },
  {
    id: 12,
    patient_name: "John (36/M)",
    patient_id: "ID-9987",
    registration_no: "123234",
    admission_type: "OP",
    mod_study: "CT Face Plain",
    mod_study_id: "1,238",
    scan_time: "6 Dec 25",
    status: "Completed",
    status_date: "2024-12-03",
    referring_phy: "Dr. David Fernandez",
    referring_phy_type: "ENT Specialist",
    hospital: "5C Hospital, Jaipur",
    hospital_id:"H-004",
    grade: "-",
    type:'clinical',
    isCritical:true,
    isDocumentUploaded:"No",
  },
  {
    id: 13,
    patient_name: "Jiya (65/M)",
    patient_id: "ID-3456",
    registration_no: "123456",
    admission_type: "OP",
    mod_study: "CT Brain Plain",
    mod_study_id: "1,230",
    scan_time: "25 Mar 2021",
    status: "Completed",
    status_date: "2025-01-17",
    referring_phy: "Dr. Gopi Saharan",
    referring_phy_type: "Neurologist",
    hospital: "5C Hospital, Bengaluru",
    hospital_id:"H-001",
    grade: "No",
    type:'clinical',
    isCritical:false,
    isDocumentUploaded:"Yes",
  },
  {
    id: 14,
    patient_name: "Niyati Mahato (71/F)",
    patient_id: "ID-3456",
    registration_no: "123456",
    admission_type: "OP",
    mod_study: "CT Abdomen & Pelvis",
    mod_study_id: "1,230",
    scan_time: "25 Mar 2021",
    status: "Completed",
    status_date: "2025-02-28",
    referring_phy: "Dr. Gopi Saharan",
    referring_phy_type: "Gastroenterologist",
    hospital: "5C Hospital, Delhi",
    hospital_id:"H-002",
    grade: "-",
    type:'clinical',
    isCritical:false,
    isDocumentUploaded:"Yes",
  },
];
